import AwesomeSlider from 'react-awesome-slider'
import 'react-awesome-slider/dist/styles.css'
import './HomeView.css'
// import banner1 from '@assets/pagina_1.jpg'
// import banner2 from '@assets/pagina_2.jpg'
// import banner3 from '@assets/pagina_3.jpg'
import withAutoplay from 'react-awesome-slider/dist/autoplay'
import { getProfile } from '@views/profile/state/profileSlice'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const AutoplaySlider = withAutoplay(AwesomeSlider)

const HomeViewTemp = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getProfile())
  }, [])

  return (
    <div className="center_view">
      <div className="home_view">
        <AutoplaySlider play={true} interval={6000} className="home_slider">
          {/* <div data-src={banner1} />
          <div data-src={banner2} />
          <div data-src={banner3} /> */}
        </AutoplaySlider>
      </div>
    </div>
  )
}

export default HomeViewTemp
